export function assignObjectFields(object = {}, keys = []) {
  return keys.reduce((resultObj, key) => {
    if (object && Object.prototype.hasOwnProperty.call(object, key)) {
      resultObj[key] = object[key]
    }
    return resultObj
  }, {})
}

export function hydrateFields(formData) {
  // Turn null to empty string
  Object.keys(formData).forEach(function (key, index) {
    if (this[key] == null) this[key] = ''
  }, formData)
}

export function dehydrateFields(formData) {
  // Turn empty string to null
  Object.keys(formData).forEach(function (key, index) {
    if (this[key] === '') this[key] = null
  }, formData)
}
